import { render } from "./PurchaseDetails.vue?vue&type=template&id=52ff3638"
import script from "./PurchaseDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__